<app-modal-shell [title]="title" size="sm" [closeDisabled]="loading" (closed)="close()">
  <div icon class="header-icon" [class.danger]="mode === 'delete'">
    <i class="bi" [class]="mode === 'delete' ? 'bi-exclamation-triangle-fill' : mode === 'changePassword' ? 'bi-key-fill' : mode === 'edit' ? 'bi-pencil-fill' : 'bi-plus-lg'"></i>
  </div>

  @if (loading) {
    <app-loader />
  }

  @if (mode === 'delete') {
    <div class="confirm-panel">
      <p class="confirm-text">
        You're about to remove <strong>{{ user?.first_name }} {{ user?.last_name }}</strong> ({{ user?.email }}) from this tenant. This action can't be undone.
      </p>
    </div>
  } @else if (mode === 'changePassword') {
    <form [formGroup]="form" class="user-form">
      <div class="form-group">
        <label for="password">New Password</label>
        <div class="input-with-icon">
          <i class="bi bi-lock"></i>
          <input id="password" type="password" placeholder="Enter new password" formControlName="password" />
        </div>
        @if (form.controls.password.invalid && form.controls.password.touched) {
          <span class="field-error">Password must be at least 6 characters.</span>
        }
      </div>
    </form>
  } @else {
    <form [formGroup]="form" class="user-form">
      <div class="form-group">
        <label for="username">Username</label>
        <div class="input-with-icon">
          <i class="bi bi-person"></i>
          <input id="username" type="text" placeholder="e.g. jane.doe" formControlName="username" />
        </div>
        @if (form.controls.username.invalid && form.controls.username.touched) {
          <span class="field-error">Username is required.</span>
        }
      </div>

      <div class="form-group">
        <label for="email">Email</label>
        <div class="input-with-icon">
          <i class="bi bi-envelope"></i>
          <input id="email" type="email" placeholder="e.g. jane.doe@example.com" formControlName="email" />
        </div>
        @if (form.controls.email.invalid && form.controls.email.touched) {
          <span class="field-error">A valid email is required.</span>
        }
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First Name</label>
          <div class="input-with-icon">
            <i class="bi bi-person-badge"></i>
            <input id="firstName" type="text" placeholder="Jane" formControlName="firstName" />
          </div>
        </div>

        <div class="form-group">
          <label for="lastName">Last Name</label>
          <div class="input-with-icon">
            <i class="bi bi-person-badge"></i>
            <input id="lastName" type="text" placeholder="Doe" formControlName="lastName" />
          </div>
        </div>
      </div>

      @if (mode === 'add') {
        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-with-icon">
            <i class="bi bi-lock"></i>
            <input id="password" type="password" placeholder="Enter password" formControlName="password" />
          </div>
          @if (form.controls.password.invalid && form.controls.password.touched) {
            <span class="field-error">Password must be at least 6 characters.</span>
          }
        </div>
      }
    </form>
  }

  <div footer>
    <button
      type="button"
      class="submit-btn"
      [class.danger]="mode === 'delete'"
      [disabled]="loading"
      (click)="submit()"
    >
      @if (mode === 'delete') {
        <i class="bi bi-trash"></i>
      } @else if (mode === 'changePassword') {
        <i class="bi bi-key-fill"></i>
      } @else if (mode === 'edit') {
        <i class="bi bi-check-lg"></i>
      } @else {
        <i class="bi bi-plus-lg"></i>
      }
      <span>{{ mode === 'delete' ? 'Remove User' : mode === 'changePassword' ? 'Update Password' : mode === 'edit' ? 'Save Changes' : 'Add User' }}</span>
    </button>
  </div>
</app-modal-shell>
